/* Sternkerze — Farbpalette folgt der Wachswahl.
   Bei Produkten mit den Optionen «Wachs» und «Farbe» zeigt die Palette
   nur die Farben, die es im gewaehlten Wachs wirklich gibt. Faellt die
   gewaehlte Farbe weg, springt die Wahl auf die erste verfuegbare. */
(function () {
  function einrichten(wurzel) {
    var wachsFeld = wurzel.querySelector('fieldset[data-handle="wachs"]');
    var farbFeld = wurzel.querySelector('fieldset[data-handle="farbe"]');
    var datenTag = wurzel.querySelector('script[type="application/json"]');
    if (!wachsFeld || !farbFeld || !datenTag) return;

    var varianten;
    try { varianten = JSON.parse(datenTag.textContent); } catch (e) { return; }

    function erlaubteFarben(wachs) {
      var raus = {};
      varianten.forEach(function (v) {
        if (v.option1 === wachs) raus[v.option2] = true;
      });
      return raus;
    }

    function anwenden() {
      var gewaehlt = wachsFeld.querySelector('input:checked');
      if (!gewaehlt) return;
      var erlaubt = erlaubteFarben(gewaehlt.value);

      var sichtbarErste = null;
      var aktiveVersteckt = false;
      farbFeld.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var label = farbFeld.querySelector('label[for="' + input.id + '"]');
        var zeigen = !!erlaubt[input.value];
        input.hidden = !zeigen;
        if (label) label.hidden = !zeigen;
        if (zeigen && !sichtbarErste) sichtbarErste = input;
        if (!zeigen && input.checked) aktiveVersteckt = true;
      });

      if (aktiveVersteckt && sichtbarErste) {
        sichtbarErste.click();
      }
    }

    wachsFeld.addEventListener('change', function () {
      // erst das Theme rechnen lassen, dann filtern
      setTimeout(anwenden, 0);
    });
    anwenden();
  }

  function start() {
    document.querySelectorAll('variant-selects').forEach(einrichten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
